module.exports = __webpack_public_path__ + "img/1 (132).e30ad568.png";